import { render, staticRenderFns } from "./ProductAmount.vue?vue&type=template&id=2593e4fc"
import script from "./ProductAmount.vue?vue&type=script&lang=js"
export * from "./ProductAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports